import { FolderTrackingStepVisibilityCondition } from './enums/folder-tracking-step-visibility-condition';

export class FolderTrackingStepCustomization {
    public stepId: number;
    public visibilityCondition: FolderTrackingStepVisibilityCondition;
    public states: number[];
    public icon: string;
    public iconMimeType: string;

    /* Propriété du web */
    public stepName: string;

    /**
     * Retourne une instance de FolderTrackingStepCustomization à partir d'une instance de Any.
     * @param other : Instance de any.
     * @returns : Instance de FolderTrackingStepCustomization.
     */
    public static from(other: any) {
        if (!!other) {
            const instance = new FolderTrackingStepCustomization();

            instance.stepId = other.stepId;
            instance.visibilityCondition = other.visibilityCondition;
            instance.states = other.states ? [...other.states] : [];
            instance.icon = other.icon;
            instance.iconMimeType = other.iconMimeType;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de FolderTrackingStepCustomization à partir d'un tableau d'instances de FolderTrackingStepCustomization.
     * @param other : Tableau d'instances de FolderTrackingStepCustomization.
     * @returns : Tableau d'instances de FolderTrackingStepCustomization.
     */
    public static fromArray(others: FolderTrackingStepCustomization[]) {
        if (!!others) {
            let stepCustomizations: FolderTrackingStepCustomization[] = [];

            others.forEach((x) => {
                const stepCustomization = FolderTrackingStepCustomization.from(x);
                stepCustomizations.push(stepCustomization);
            });

            return stepCustomizations;
        } else {
            return null;
        }
    }
}
